import React, { useState, useEffect } from 'react';
import '../css/Admin/InsProfile.css';
import UserLogo from '../assets/user-logo.png';
import ResponseMsg2 from '../general/ResponseMsg2';
import HeadingArea from '../general/HeadingArea';

const InsProfile = ({ userData, setLoading }) => {
  const [formData, setFormData] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [familyPhoto, setFamilyPhoto] = useState(null);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });

console.log(userData);

  useEffect(() => {
    if (userData) {
      setFormData({
        name: userData.name || '',
        designation: userData.designation || '',
        dob: userData.dob || '',
        doj: userData.doj || '',
        gender: userData.gender || '',
        father: userData.father || '',
        mother: userData.mother || '',
        blood_grp: userData.blood_grp || '',
        mobile: userData.mobile || '',
        email: userData.email || '',
        user_id: userData.user_id || '',
        address: userData.address || '',
        pass: userData.pass || ''
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === 'profile_pic') {
      setProfilePic(files[0]);
    } else if (name === 'family_photo') {
      setFamilyPhoto(files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formPayload = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });

    if (profilePic) formPayload.append('profile_pic', profilePic);
    if (familyPhoto) formPayload.append('family_photo', familyPhoto);
    setLoading(true);

    try {
      const res = await fetch(`https://api.kcian.in/update-profile/${userData.id}`, {
        method: 'PUT',
        body: formPayload,
      });

      const result = await res.json();
    setLoading(false);
      if(res.ok){
                            localStorage.setItem('userData', JSON.stringify(result));
      setResponse2({ message: 'Profile Updated Successfully!', status: 'success' });
      setTimeout(() => {setResponse2({ message: '', status: '' }); window.location.reload()}, 2000);
      }else {
          setLoading(false);
      setResponse2({ message: result.message || 'Something Went Wrong', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 2000);
      }
    } catch (err) {
          setLoading(false);
      console.error('Error updating profile:', err);
    }
  };

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>

          <HeadingArea message1='General Settings' message2='School Profile' />


          {!formData ? (
            <div className='text-center my-5'>Loading Profile...</div>
          ) : (
            <div className='row'>
              
              <div className='col-lg-8 col-12 my-2'>
                <div>
                  <p className='text-center profile-heading'>Update Profile</p>

                <form
                  className='row rounded-3 py-3'
                  onSubmit={handleSubmit}
                  encType='multipart/form-data'
                >
                  {/* Input Fields */}
                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>School Name*</label>
                    <input
                      type='text'
                      name='name'
                      className='profile-input'
                      value={formData.name}
                      onChange={handleChange}
                    />
                    </div>
                  </div>


                  <div className='col-md-6 mb-4'>
                                        <div className='profile-input-area'>
                    <label className='profile-badge'>User Id*</label>
                    <input
                      type='text'
                      name='user_id'
                      className='profile-input'
                      value={formData.user_id || ''}
                      disabled
                      onChange={handleChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Designation*</label>
                    <input
                      type='text'
                      name='designation'
                      className='profile-input'
                      value={formData.designation}
                      onChange={handleChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                                        <div className='profile-input-area'>
                    <label className='profile-badge'>Date of Birth</label>
                    <input
                      type='date'
                      name='dob'
                      className='profile-input'
                      value={formData.dob || ''}
                      onChange={handleChange}
                    />
                    </div>
                  </div>


                                    <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Mobile*</label>
                    <input
                      type='tel'
                      name='mobile'
                      maxLength={10}
                      className='profile-input'
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                    </div>
                  </div>
                  
                  
                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Gender</label>
                    <select
                      name='gender'
                      className='profile-input'
                      value={formData.gender}
                      onChange={handleChange}
                    >
                      <option value=''>Select</option>
                      <option value='Male'>Male</option>
                      <option value='Female'>Female</option>
                      <option value='Other'>Other</option>
                    </select>
                    </div>
                  </div>


                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Email</label>
                    <input
                      type='email'
                      name='email'
                      className='profile-input'
                      value={formData.email}
                      onChange={handleChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Father's Name</label>
                    <input
                      type='text'
                      name='father'
                      className='profile-input'
                      value={formData.father}
                      onChange={handleChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Date of Joining*</label>
                    <input
                      type='date'
                      name='doj'
                      className='profile-input'
                      value={formData.doj || ''}
                      onChange={handleChange}
                    />
                    </div>
                  </div>
                  

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Mother's Name</label>
                    <input
                      type='text'
                      name='mother'
                      className='profile-input'
                      value={formData.mother}
                      onChange={handleChange}
                    />
                    </div>
                  </div>


                                    <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Address</label>
                    <input
                      type='text'
                      name='address'
                      className='profile-input'
                      value={formData.address}
                      onChange={handleChange}
                    />
                    </div>
                  </div>


                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Blood Group</label>
                    <input
                      type='text'
                      name='blood_grp'
                      className='profile-input'
                      value={formData.blood_grp}
                      onChange={handleChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Profile Photo</label>
                    <input
                      type='file'
                      name='profile_pic'
                      className='profile-input'
                      onChange={handleFileChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Family Photo</label>
                    <input
                      type='file'
                      name='family_photo'
                      className='profile-input'
                      onChange={handleFileChange}
                    />
                    </div>
                  </div>

                  <div className='col-md-6 mb-4'>
                    <div className='profile-input-area'>
                    <label className='profile-badge'>Password</label>
                    <input
                      type='text'
                      name='pass'
                      className='profile-input'
                      value={formData.pass}
                      onChange={handleChange}
                    />
                    </div>
                  </div>


       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                  <div className='col-12 text-center'>
                    <button type='submit' className='profile-btn'>
                     <i class="fa-solid fa-rotate"></i> Save Changes
                    </button>
                  </div>
                </form>

                </div>
              </div>
              {/* left ends */}

              <div className='col-lg-4 col-12 my-2 align-content-center'>
                <div className='profile-card '>
                  <span className='profile-badge2'>
                    Profile View
                  </span>
                  <br />
                  <div className='text-center'>
<img
  src={
    userData.profile_pic && userData.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${userData.profile_pic}`
      : UserLogo
  }
  className='profile-img'
  alt='Profile'
/>
                    <p className='mt-2 mb-0 fw-bold fm-mont'>{formData.name}</p>
                    <span className='para-text fm-mont'>{formData.designation}</span>
                  </div>
{/* center ends */}
                    <hr />

<span className='profile-text'><i class="fa-solid fa-mobile-screen"></i> Mobile</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {userData.mobile}</span><br />

<span className='profile-text'><i class="fa-solid fa-mobile-screen"></i> Email</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {userData.email}</span><br />

<span className='profile-text'><i class="fa-solid fa-mobile-screen"></i> DOJ</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {userData.doj}</span><br />

<span className='profile-text'><i class="fa-solid fa-mobile-screen"></i> Address</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {userData.address}</span><br />


                </div>

                                <div className='profile-card mt-3'>
                  <span className='profile-badge2'>
                    Family Photo
                  </span>
                  <br />
                  <div className='text-center my-3'>
                  {userData.family_photo == null ? <p className='para-text fw-semibold text-muted'>Not Added Yet.</p> : 
                  <img src={`https://api.kcian.in/inUploads/${userData.family_photo}`} className='img-fluid' alt='Family' />}</div>
                  </div>

              </div>
{/* right ends */}


            </div>
          )}
            {/* row ends */}

        </div>
      </section>
    </>
  );
};

export default InsProfile;
